import { captureException } from '@sentry/browser';
import { SentryEventType } from '@shared/sentry';
import { ContentScriptStore } from '../store';

let onMessage: (event: MessageEvent) => void;

export function startHandlingSentryErrors(store: ContentScriptStore, errors: Error[]): void {
  onMessage = async (event: MessageEvent) => {
    if (event.origin === window.location.origin && event.data.type === SentryEventType.Error) {
      if (store.sentryInitialized$.value) {
        captureException(event.data.content.error);
      } else {
        errors.push(event.data.content.error);
      }
    }
  };
  window.addEventListener('message', onMessage);
}

export function removeSentryErrorsHandler(): void {
  window.removeEventListener('message', onMessage);
}
